import { atom } from 'recoil'
import { INavigationState } from './navigation.types'

const navigationAtom = atom<INavigationState>({ key: 'navigation', default: { star: null, level: null, rocket: null } })
export default navigationAtom
